import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

import { BrowserService } from 'app/core/browser/services/browser.service';
import { RouterStateUrlInterface } from 'app/core/browser/state/models/router-state-url.interface';
import { UserInterface } from 'app/core/user/models';

import { AppRoute } from 'app/app-layout/constants';
import { NavItemSecondaryInterface } from 'app/app-layout/models';
import { SiteLogoService } from 'app/site-logo/services/site-logo.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cz-sidenav-secondary',
  templateUrl: './sidenav-secondary.component.html',
  styleUrls: ['./sidenav-secondary.component.scss'],
})
export class SidenavSecondaryComponent implements OnDestroy, OnInit {

  @Input() public readonly navItems$: NavItemSecondaryInterface[];
  @Input() public readonly user$: UserInterface;

  public routerStateSubscription: Subscription;
  public secondaryNavBreadcrumb: string;
  public routePrefix: string;
  public logoHref: string;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _browserService: BrowserService,
    private readonly _siteLogoService: SiteLogoService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    public route: Router,
  ) {}

  public ngOnInit(): void {
    this.routerStateSubscription =
      this._browserService.selectRouterState().subscribe((routerState: RouterStateUrlInterface) => {
        if (!routerState) { return; }

        const primaryNavAppRoute: AppRoute = this._browserService.determinePrimaryNavAppRoute(routerState.url);
        this.routePrefix = '/';
        switch (primaryNavAppRoute) {
          case AppRoute.myZone:
            this.secondaryNavBreadcrumb = '$my_zone_nav_secondary_label';
            break;
          case AppRoute.reports:
            this.secondaryNavBreadcrumb = '$reports_nav_secondary_label';
            break;
          case AppRoute.users:
            this.secondaryNavBreadcrumb = '$users_system_users_nav_secondary_label';
            break;
          case AppRoute.administration:
            this.secondaryNavBreadcrumb = '$lng_adm_menu_tit6';
            this.routePrefix = 'admin/';
            break;
          case AppRoute.training:
            this.secondaryNavBreadcrumb = '$link_training';
            break;
          case AppRoute.help:
            this.secondaryNavBreadcrumb = '$nav_primary_help';
            break;
          default:
            this.secondaryNavBreadcrumb = '';
            break;
        }
      });

    this._siteLogoService.loadSiteLogo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((stateLogoHref: string) => {
        if(!stateLogoHref) { return; }
        this.logoHref = stateLogoHref;
        this._changeDetectorRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    if (this.routerStateSubscription) {
      this.routerStateSubscription.unsubscribe();
    }
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
